import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gongyingshangguanli",
  "use": "icon-gongyingshangguanli-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-gongyingshangguanli\"><path d=\"M8.644 9.274A4.376 4.376 0 0011 5.398c0-2.41-1.96-4.37-4.37-4.37s-4.37 1.96-4.37 4.37c0 1.684.956 3.146 2.354 3.876-2.372.76-4.078 2.822-4.078 5.242a.45.45 0 00.9 0c0-2.568 2.33-4.656 5.194-4.656s5.194 2.088 5.194 4.656a.45.45 0 00.9 0c-.002-2.42-1.708-4.482-4.08-5.242zM3.158 5.398a3.475 3.475 0 013.472-3.47 3.474 3.474 0 013.47 3.47 3.474 3.474 0 01-3.47 3.47 3.474 3.474 0 01-3.472-3.47zm9.66 2.998a3.17 3.17 0 001.45-2.662 3.178 3.178 0 00-3.174-3.174.45.45 0 000 .9 2.276 2.276 0 012.274 2.274 2.276 2.276 0 01-2.274 2.274.45.45 0 00-.45.45c0 .01.002.02.004.032 0 .01-.004.02-.004.032 0 .248.202.45.45.45 1.914 0 3.47 1.39 3.47 3.098a.45.45 0 00.9 0c.002-1.646-1.09-3.062-2.646-3.674z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/gongyingshangguanli.svg
// module id = 467
// module chunks = 4